import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Sidebar from '../Sidebar';
import Header from '../Header';
import Settings from './Settings';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../../store/authSlice';

const SettingsPageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 280px;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
`;

const SettingsPage = () => {
  const { user, isAuthenticated } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('settings');

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  if (!isAuthenticated) {
    return null; // Will redirect to login
  }

  return (
    <SettingsPageContainer>
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <MainContent>
        <Header user={user} onLogout={handleLogout} />
        <ContentArea>
          <Settings />
        </ContentArea>
      </MainContent>
    </SettingsPageContainer>
  );
};

export default SettingsPage;
